import { createContext, useContext } from 'react';

export interface SourceParam {
    key: string;
    value: string;
}

export interface SourceCall {
    request: string;
    params: SourceParam[];
    queried_at?: string;
    // Page numbers extracted from an MCP result shaped like
    // {"chunks": [{"page": int, ...}, ...]} (e.g. konstant_lokalplaner's
    // search_lokalplan_fabric_database) — see handle_runnable_messages.py's
    // pending_pages. Absent/empty when the source has no page concept.
    pages?: number[];
}

export interface SourceSection {
    name: string;
    calls: SourceCall[];
    config_type?: string;
    configType?: string;
}

interface SourceSummaryState {
    sources: SourceSection[] | null;
    streaming: boolean;
}

const SourceSummaryContext = createContext<SourceSummaryState>({
    sources: null,
    streaming: false
});

interface ProviderProps {
    sources: SourceSection[] | null;
    streaming?: boolean;
    children: React.ReactNode;
}

export function SourceSummaryProvider({
    sources,
    streaming = false,
    children
}: ProviderProps) {
    return (
        <SourceSummaryContext.Provider value={{ sources, streaming }}>
            {children}
        </SourceSummaryContext.Provider>
    );
}

export const useSourceSummary = () => useContext(SourceSummaryContext);
